import {
  AddressFieldLabels,
  Country,
  CreateAddressRequest,
  UpdateAddressRequest,
  UserAddress,
} from '../types/addresses';
import { BaseApiService } from './baseApiService';

/**
 * Service for address and country operations
 */
class AddressService extends BaseApiService {
  // Country endpoints
  async getCountries(): Promise<Country[]> {
    await this.ensureInitialized();
    const response = await this.api.get('/country');
    return response.data.countries || response.data;
  }

  async getCountryByCode(countryCode: string): Promise<Country> {
    await this.ensureInitialized();
    const response = await this.api.get(`/country/${countryCode}`);
    return response.data;
  }

  async getAddressFieldLabels(
    countryCode: string
  ): Promise<AddressFieldLabels> {
    await this.ensureInitialized();
    const response = await this.api.get(
      `/country/${countryCode}/address-fields`
    );
    return response.data;
  }

  // Address endpoints
  async getAddresses(): Promise<UserAddress[]> {
    await this.ensureInitialized();
    const response = await this.api.get('/address');
    return response.data.addresses || response.data;
  }

  async createAddress(addressData: CreateAddressRequest): Promise<UserAddress> {
    await this.ensureInitialized();
    const response = await this.api.post('/address', addressData);
    return response.data.address || response.data;
  }

  async updateAddress(
    addressId: number,
    addressData: UpdateAddressRequest
  ): Promise<UserAddress> {
    await this.ensureInitialized();
    const response = await this.api.put(`/address/${addressId}`, addressData);
    return response.data.address || response.data;
  }

  async deleteAddress(addressId: number): Promise<void> {
    await this.ensureInitialized();
    await this.api.delete(`/address/${addressId}`);
  }

  async setDefaultAddress(addressId: number): Promise<void> {
    await this.ensureInitialized();
    await this.api.put(`/address/${addressId}/set-default`);
  }
}

export const addressService = new AddressService();
export default addressService;
